namespace $.$$ {

	$mol_style_define( $bog_pazzle_help, {

		display: 'flex',
		flexDirection: 'column',
		padding: $mol_gap.block,
		background: { color: $mol_theme.card },
		border: { radius: $mol_gap.round },
		boxShadow: `0 0 0 1px ${ $mol_theme.line }`,

	} )

}
